﻿$.fn.pageMe = function (opts) {
    var $this = this,
        defaults = {
            perPage: 7,
            showPrevNext: false,
            numbersPerPage: 5,
            numbersPerPageMobile: 2,
            hidePageNumbers: false,
            showFirstLast: true
        },
        settings = $.extend(defaults, opts);

    var mobileBreakpoint = 530;
    var listElement = $this;
    var perPage = settings.perPage;
    var children = listElement.children();
    var pager = $('.pagination');

    if (typeof settings.childSelector != "undefined") {
        children = listElement.find(settings.childSelector);
    }

    if (typeof settings.pagerSelector != "undefined") {
        pager = $(settings.pagerSelector);
    }

    var numItems = children.size();
    var numPages = Math.ceil(numItems / perPage);

    pager.data("curr", 0);

    if (settings.showFirstLast) {
        $('<li class="first_link"><a href="#"><</a></li>').appendTo(pager);
    }
    if (settings.showPrevNext) {
        $('<li class="prev_link"><a href="#">«</a></li>').appendTo(pager);
    }

    var curr = 0;
    while (numPages > curr && (settings.hidePageNumbers == false)) {
        $('<li class="page_link"><a href="#">' + (curr + 1) + '</a></li>').appendTo(pager);
        curr++;
    }

    
    if (getNumbersPerPage() > 1) {
        $('.page_link').hide();
        $('.page_link').slice(pager.data("curr"), getNumbersPerPage()).show();
    }

    if (settings.showPrevNext) {
        $('<li class="next_link"><a href="#">»</a></li>').appendTo(pager);
    }
    if (settings.showFirstLast) {
        $('<li class="last_link"><a href="#">></a></li>').appendTo(pager);
    }

    pager.find('.page_link:first a').addClass('active');
    pager.find('.prev_link').hide();
    pager.find('.first_link').hide();

    if (numPages <= 1) {
        pager.find('.next_link').hide();
        pager.find('.last_link').hide();
    }
    pager.children().eq(2).addClass("active");

    children.hide();
    children.slice(0, perPage).show();

    pager.find('li.page_link a').click(function () {
        var clickedPage = $(this).html().valueOf() - 1;
        goTo(clickedPage, perPage);
        return false;
    });
    pager.find('li.first_link a').click(function () {
        first();
        return false;
    });

    pager.find('li.prev_link a').click(function () {
        previous();
        return false;
    });
    pager.find('li.next_link a').click(function () {
        next();
        return false;
    });
    pager.find('li.last_link a').click(function () {
        last();
        return false;
    });
    function previous() {
        var goToPage = parseInt(pager.data("curr")) - 1;
        goTo(goToPage);
    }

    function next() {
        goToPage = parseInt(pager.data("curr")) + 1;
        goTo(goToPage);
    }

    function first() {
        var goToPage = 0;
        goTo(goToPage);
    }

    function last() {
        var goToPage = numPages - 1;
        goTo(goToPage);
    }

    function getNumbersPerPage() {
        //  if mobile, return  mobile value
        if (window.innerWidth <= mobileBreakpoint) {
            return settings.numbersPerPageMobile;

        }
        return settings.numbersPerPage;
    }

    function goTo(page) {
        var startAt = page * perPage,
            endOn = startAt + perPage;

        children.css('display', 'none').slice(startAt, endOn).show();

        if (page >= 1) {
            pager.find('.prev_link').show();
            pager.find('.first_link').show();
        }
        else {
            pager.find('.prev_link').hide();
            pager.find('.first_link').hide();
        }

        if ((page+1) < numPages) {
            pager.find('.next_link').show();
            pager.find('.last_link').show();
        }
        else {
            pager.find('.next_link').hide();
            pager.find('.last_link').hide();
        }

        pager.data("curr", page);

        //   if we have a set number of page dots to show and we have more items than that
        if (getNumbersPerPage() > 1 && getNumbersPerPage() <= numPages) {

            $('.page_link').hide();

            if (page < (numPages - getNumbersPerPage())) {
                var pages = $('.page_link').slice(page, page + getNumbersPerPage());
                pages.show();
            } else {
                $('.page_link').slice(numPages - getNumbersPerPage()).show();
            }


            /*
            if (page == 1) {
                //  are we on page 1
                $('.page_link').slice(page, settings.numbersPerPage + page).show();
            }
            else {
                //  we are beyond
                $('.page_link').slice(numPages - settings.numbersPerPage).show();
            }*/
        }

        pager.find(".active").removeClass("active");

        pager.children(".page_link").eq(page).children("a").addClass("active");

        
        if (settings.onPage) settings.onPage();

    }

    var isDesktop = (window.innerWidth > mobileBreakpoint? true : false );
    
    $(window).resize(function () {
        var goToPage = parseInt(pager.data("curr"));
        if (window.innerWidth > mobileBreakpoint && !isDesktop) {
            //  change to desktop mode
            isDesktop = true;
            goTo(goToPage);

        } else if (window.innerWidth <= mobileBreakpoint && isDesktop) {
            //  change to mobile mode
            isDesktop = false;
            goTo(goToPage);
        }

    });


};